import { gql } from '__generated__';

export default gql(`
  mutation LeaveWaitlist($input: LeaveWaitlistInput!) {
    leaveWaitlist(input: $input)
  }
`);
